import React from 'react';
import ProfileUser from '../components/container/ProfileUser';

const Profile = () => {
  return <ProfileUser />;
};

export default Profile;
